export default "__VITE_ASSET__pAu5Sg4$__"